import { ActivityEntityName, MetadataEntityFieldDomain } from '@jms/model';
import { MetadataService } from '@workbuddy/ui/services/metadata.service';
import { SurfaceEntityMetadataUnavailableError } from '@workbuddy/ui/v2/surface.engine';

export function requireSurfaceEntityMetadata(metadataService: MetadataService, entity: ActivityEntityName): MetadataEntityFieldDomain {

  const metadata = metadataService.getCached(entity);
  if (!metadata) throw new SurfaceEntityMetadataUnavailableError(entity);
  return new MetadataEntityFieldDomain(metadata);
}
